const menus = [
  {
    id: 1,
    title: "Home",
    link: "home",
    offset: -50,
    label: "Menuju Tampilan Home",
  },
  {
    id: 2,
    title: "About",
    link: "about",
    offset: 50,
    label: "Menuju Tampilan About",
  },
  {
    id: 3,
    title: "Services",
    link: "services",
    offset: 50,
    label: "Menuju Tampilan Services",
  },
  {
    id: 4,
    title: "Client",
    link: "client",
    offset: -50,
    label: "Menuju Tampilan Clients",
  },
  {
    id: 5,
    title: "Portofolio",
    link: "portofolio",
    offset: 50,
    label: "Menuju Tampilan Portofolio",
  },
  {
    id: 6,
    title: "Product",
    link: "product",
    offset: 50,
    label: "Menuju Tampilan Products",
  },
];

export default menus;
